/**
 * Format integer cents as a localized currency string (UI only).
 */
export function formatMoneyCents(
  cents: number,
  currency = 'EUR',
  locale = 'fr-FR',
): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format(cents / 100)
}

/**
 * Format cents as a plain decimal string ("12.34") without currency symbol.
 */
export function formatMoneyCentsDecimal(cents: number): string {
  const whole = Math.trunc(cents / 100)
  const frac = Math.abs(cents % 100)
  return `${whole}.${String(frac).padStart(2, '0')}`
}
